import { Action } from '@ngrx/store';
import { IJobsiteSalesArea, Order } from '@cemex-core/cmx-api';
import { MultipleStdLotSizeRes } from '@cemex-core/cmx-api/models/std-lot-size/multiple-std-lot-size-res';
import { TransportationList } from '@cemex-core/cmx-api/models/jobsite-std-lot/transportation-list';

export enum OneClickStandardLotActionTypes {
  LOAD_STANDARD_LOT = '[One Click] Load standard lot',
  LOAD_STANDARD_LOT_COMPLETE = '[One Click] Load standard lot completed',
  SELECT_STANDARD_LOT = '[One Click] Select standard lot',
  RESET_STANDARD_LOT = '[One Click] Reset standard lot',
}

export class OneClickLoadStandardLotAction implements Action {
  readonly type = OneClickStandardLotActionTypes.LOAD_STANDARD_LOT;

  constructor(public payload: Order, public salesArea: IJobsiteSalesArea[]) {}
}

export class OneClickLoadStandardLotCompleteAction implements Action {
  readonly type = OneClickStandardLotActionTypes.LOAD_STANDARD_LOT_COMPLETE;

  constructor(public payload: MultipleStdLotSizeRes) {}
}

export class OneClickSelectStandardLotAction implements Action {
  readonly type = OneClickStandardLotActionTypes.SELECT_STANDARD_LOT;

  constructor(public payload: TransportationList) {}
}

export class OneClickResetStandardLotAction implements Action {
  readonly type = OneClickStandardLotActionTypes.RESET_STANDARD_LOT;

  constructor() {}
}

export type OneClickStandardLotActions =
  | OneClickLoadStandardLotAction
  | OneClickLoadStandardLotCompleteAction
  | OneClickSelectStandardLotAction
  | OneClickResetStandardLotAction;
